(function () {
  const SECTION_ID = 'my-cart-drawer';

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.bind();
      this.updateProgress();
      window.CartDrawer = this;
    }

    open()  { document.body.classList.add('cd-open'); this.classList.add('is-open'); }
    close() { document.body.classList.remove('cd-open'); this.classList.remove('is-open'); }

    bind() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cd-close]')) { this.close(); return; }

        const add = e.target.closest('[data-cd-add]');
        if (add) { this.addUpsell(add); return; }

        const remove = e.target.closest('[data-cd-remove]');
        if (remove) { this.changeQty(remove.closest('[data-cd-item]').dataset.key, 0); return; }

        const qtyBtn = e.target.closest('[data-cd-qty]');
        if (qtyBtn) { this.changeQty(qtyBtn.closest('[data-cd-item]').dataset.key, qtyBtn.dataset.cdQty); return; }
      });

      this.addEventListener('submit', (e) => {
        const form = e.target.closest('[data-cd-discount]');
        if (!form) return;
        e.preventDefault();
        const code = form.querySelector('input[name="discount"]').value.trim();
        if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
    }

    async addUpsell(btn) {
      const card = btn.closest('[data-cd-upsell]');
      const id = card.querySelector('[data-cd-variant]').value;
      btn.disabled = true; btn.classList.add('is-loading');
      await this.post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      this.open();
    }

    async changeQty(key, qty) {
      await this.post('/cart/change.js', { id: key, quantity: Number(qty) });
    }

    async post(url, body) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ ...body, sections: [SECTION_ID], sections_url: window.location.pathname }),
        });
        const data = await res.json();
        const html = data.sections && data.sections[SECTION_ID];
        if (html) this.render(html);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      } catch (err) { console.error('[cart-drawer]', err); }
    }

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('my-cart-drawer');
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      this.updateProgress();
    }

    updateProgress() {
      const wrap = this.querySelector('[data-cd-progress]');
      if (!wrap) return;
      const count = Number(wrap.dataset.count || 0);
      const qtys = (this.dataset.tierQtys || '').split(',').map(Number);
      const pcts = (this.dataset.tierPcts || '').split(',').map(Number);
      const last = qtys[qtys.length - 1] || 1;

      let curPct = null, nextQty = null, nextPct = null;
      qtys.forEach((q, i) => { if (count >= q) curPct = pcts[i]; });
      for (let i = 0; i < qtys.length; i++) { if (count < qtys[i]) { nextQty = qtys[i]; nextPct = pcts[i]; break; } }

      const msg = wrap.querySelector('[data-cd-progress-msg]');
      if (msg) {
        msg.innerHTML = nextQty
          ? `Add <b>${nextQty - count} more</b> and <b>save ${nextPct}%</b> on your entire order`
          : `You've unlocked <b>${curPct}% OFF</b> your entire order 🎉`;
      }
      const fill = wrap.querySelector('[data-cd-progress-fill]');
      if (fill) fill.style.width = Math.min(100, (count / last) * 100) + '%';
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  // Open drawer from any [data-cd-open] trigger
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cd-open]')) {
      e.preventDefault();
      if (window.CartDrawer) window.CartDrawer.open();
    }
  });

  // Intercept product-hero-buybox form submit
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[data-add-button]');
    const btnText = form.querySelector('[data-add-text]');
    const originalText = btnText ? btnText.textContent : null;
    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding…';

    try {
      const body = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body,
      });
      const data = await res.json();
      if (data.status) { console.error('[cart-drawer] add failed', data); return; }
      await window.CartDrawer.post('/cart/change.js', { id: data.id, quantity: data.quantity });
      window.CartDrawer.open();
    } catch (err) {
      console.error('[cart-drawer]', err);
    } finally {
      if (btn) btn.disabled = false;
      if (btnText && originalText) btnText.textContent = originalText;
    }
  });

})();